import { colors } from '../styles/colors';

// Функция для определения цвета прогресса на основе значения
export const colorProgress = (value) => {
    if (value < 50) {
        return colors.status.low;
    }

    if (value >= 50 && value < 100) {
        return colors.status.medium;
    }

    return colors.status.high;
}